<template>
  <v-container class="shopStartPage">
    <side-navigation/>
    <cart-drawer/>
    <inventory-drawer/>
    <scanner-dialog/>
    <router-view/>
  </v-container>
</template>

<script>
import SideNavigation from "@/app/global/sideNavigation";
import CartDrawer from "@/app/cart/cartDrawer";
import ScannerDialog from "@/app/scanner/scannerDialog";
import InventoryDrawer from "@/app/inventory/inventoryDrawer";
export default {
name: "userSkeleton",
  components: {InventoryDrawer, ScannerDialog, CartDrawer, SideNavigation}
}
</script>

<style scoped>

</style>
